function getImagePaddingBottom(image) {
  const paddingBottomValue = (image.naturalHeight / image.naturalWidth) * 100
  return `${paddingBottomValue}%`
}

export default getImagePaddingBottom
